<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Approval-process',
};
</script>

<style>

</style>
